export default __webpack_public_path__ + "static/media/genes@3x.9f7d17ca.png";